/**
 * Add to Babylist Button — save products to a Babylist registry
 *
 * Declares one web-accessible-resource group matched to http and https origins with no
 * `use_dynamic_url`, exposing the fonts under `assets/*.woff(2)` plus two scripts:
 * `assets/babylistScraper.js` and `clientSide.js`. Both scripts resolve from any page
 * at a fixed URL.
 *
 * `babylistScraper.js` is the cleanest signal — a vendor-named path served only when
 * the extension is installed, so fetching it is conclusive. `clientSide.js` corroborates.
 *
 * Manifest verified against version 3.1.13.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jcmljanephecacpljcpiogonhhadfpda';

export const addToBabylistButton: ExtensionDefinition = {
  id: ID,
  name: 'Add to Babylist Button',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Static WAR on http(s) origins with no dynamic URL. Fetching the vendor-named ' +
    'babylistScraper.js is conclusive; clientSide.js corroborates.',
  signals: [
    {
      id: 'war-babylist-scraper-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/babylistScraper.js — a vendor-named scraper script exposed to ' +
        'every http(s) origin at a fixed URL. The name makes the path distinctive.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/babylistScraper.js'),
    },
    {
      id: 'war-client-side-js',
      kind: 'web-accessible-resource',
      description: 'Fetch clientSide.js — the injected client script, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'clientSide.js'),
    },
  ],
};
